import { render, staticRenderFns } from "./surveyintro.vue?vue&type=template&id=45b99fef&scoped=true"
import script from "./surveyintro.vue?vue&type=script&lang=js"
export * from "./surveyintro.vue?vue&type=script&lang=js"
import style0 from "./surveyintro.vue?vue&type=style&index=0&id=45b99fef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_sniwsisxdvcgzet3yrvlfqnueq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b99fef",
  null
  
)

export default component.exports